import { useIsLeftNavCollapsed } from './leftNavCollapseStore';
import { useIsLeftNavCollapseEnabled } from './useIsLeftNavCollapseEnabled';

export const useIsLeftNavCollapsedActive = (): boolean => {
  const isLeftNavCollapseEnabled = useIsLeftNavCollapseEnabled();
  const isLeftNavCollapsed = useIsLeftNavCollapsed();

  return isLeftNavCollapseEnabled && isLeftNavCollapsed;
};
